module.exports = __webpack_public_path__ + "static/media/login.4a46f9cd.jpg";